import jsPDF from "jspdf";
import QRCode from "qrcode";
import React, { useCallback, useEffect, useState } from "react";

export default function PrintQRCodes({ surveys }) {
  const [surveyUrls, setSurveyUrls] = useState();

  useEffect(() => {
    setSurveyUrls(getSurveyUrls(surveys));
  }, [surveys]);

  const getSurveyUrls = (surveys) => {
    const teacherUrls = surveys.teacher.map(
      (s) => `${window.location.origin}/umfrage/${s.tan}`
    );
    const expertUrls = surveys.expert.map(
      (s) => `${window.location.origin}/umfrage/${s.tan}`
    );
    const studentUrls = surveys.student.map(
      (s) => `${window.location.origin}/umfrage/${s.tan}`
    );
    return {
      teacherUrls,
      expertUrls,
      studentUrls,
    };
  };

  const generateQRCodesByGroup = async (doc, urls, title) => {
    let x = 20;
    let y = 40;

    for (let i = 0; i < urls.length; i++) {
      if (i === 0) {
        doc.setFontSize(18).setFont(undefined, "bold");
        doc.text(title, 20, 20).setFontSize(14).setFont(undefined, "normal");
      }

      const canvas = await QRCode.toCanvas(urls[i]);
      doc.addImage(canvas.toDataURL("image/jpeg"), "JPEG", x, y, 50, 50);

      // Add the URL text after the QR code
      const urlText = urls[i].split("/");
      doc.text(urlText[urlText.length - 1], x + 25, y, { align: "center" });
      doc.setFontSize(6);
      doc.text(window.location.origin, x + 25, y + 50, { align: "center" });
      doc.setFontSize(14);

      x += 60;
      if ((i + 1) % 3 === 0) {
        y += 90;
        x = 20;
      }

      // Add a new page after every 9 QR codes
      if ((i + 1) % 9 === 0) {
        doc.addPage();
        doc.setFontSize(18).setFont(undefined, "bold");
        doc.text(title, 20, 20).setFontSize(14).setFont(undefined, "normal");
        x = 20;
        y = 40;
      }
    }
  };

  const generatePdf = useCallback(async () => {
    const doc = new jsPDF();

    // Generate Teacher Urls
    await generateQRCodesByGroup(
      doc,
      surveyUrls.teacherUrls,
      "Zugangscodes Lehrpersonen"
    );
    doc.addPage();

    // Generate Expert Urls
    await generateQRCodesByGroup(
      doc,
      surveyUrls.expertUrls,
      "Zugangscodes Beobachter*innen"
    );
    doc.addPage();

    // Generate Students Urls
    await generateQRCodesByGroup(
      doc,
      surveyUrls.studentUrls,
      "Zugangscodes Schüler*innen"
    );

    const pdfBlob = doc.output("blob");
    const pdfUrl = URL.createObjectURL(pdfBlob);
    window.open(pdfUrl, "_blank");
  }, [surveyUrls]);

  return (
    <button className="Button color-primary size-large" onClick={generatePdf}>
      Liste ausdrucken
    </button>
  );
}
